module.exports = __webpack_public_path__ + "static/media/icon-post-album-off.7ad4aaa2.svg";